export default {
  setSchedule(state, value) {
    state.schedules = value
  },

  setInputType(state, value) {
    state.schedulePage.inputType = value
  },
  setInputTemplate(state, value) {
    state.schedulePage.inputTemplate = value
  },
  setShowModal(state, value) {
    state.schedulePage.showModal = value
  },
  setItemSchedules(state, value) {
    state.schedulePage.selectedItemData = value
  },
  setScheduleStatistic(state, payload) {
    state.scheduleStatistic = payload
  },
}
